export type CreatorAttribution = {
  canEdit?: boolean
  createdByName?: string | null
}

export function getCreatorByline(item: CreatorAttribution): string | null {
  if (item.canEdit !== false) return null

  const creatorName = item.createdByName?.trim()
  return creatorName ? `by ${creatorName}` : null
}
